import { useField, useFormikContext } from 'formik';
import { useState } from 'react';
import { Button } from 'react-bootstrap';
import LabelRequired from 'src/app/modules/component/LabelRequired';
import TextField from 'src/app/modules/component/TextField';
import ModalChonKetQuaDichVu from 'src/app/modules/phan-he-kham-benh/components/tab-kham-benh/modal-chon-ket-qua-dich-vu/ModalChonKetQuaDichVu';
import clsx from 'clsx';

type Props = {
	patientInfo: any;
	label?: string;
	name?: string;
	labelClassName?: string;
	inputClassName?: string;
	isView?: boolean;
};

const TomTatKetQuaCanLamSang = ({
	patientInfo,
	label = '2. Tóm tắt kết quả xét nghiệm cận lâm sàng có giá trị chẩn đoán:',
	name = 'forms.paraclinicalSummary',
	labelClassName,
	inputClassName = 'pl-6',
	isView = false,
}: Props) => {
	const { values } = useFormikContext<any>();
	const [, , { setValue }] = useField(name);
	const [openChonKetQuaDialog, setOpenChonKetQuaDialog] = useState(false);

	const getKetQuaCanLamSang = (values: any[]) => {
		const result = values
			.map((item: any) => `${item.tenDichVu} ${item.ketQua ? `(${item.ketQua})` : ''}`)
			.join(', ');

		setValue(result);
		setOpenChonKetQuaDialog(false);
	};

	const getValues = () => {
		return name?.split('.').reduce((prev: any, curr: any) => prev?.[curr], values);
	};
	
	return (
		<div>
			<div className="d-flex align-items-baseline spaces pb-4">
				<LabelRequired label={label} className={labelClassName} />
				<Button
					className="link-info bg-white text-decoration-underline spaces pb-0"
					onClick={() => {
						setOpenChonKetQuaDialog(true);
					}}
					disabled={isView}
				>
					Chọn dịch vụ
				</Button>
			</div>

			<TextField
				as="textarea"
				name={name}
				value={getValues() || ""}
				className={clsx('spaces resize-none', inputClassName)}
				disabled={isView}
			/>

			{openChonKetQuaDialog && (
				<ModalChonKetQuaDichVu
					open={openChonKetQuaDialog}
					handleClose={() => setOpenChonKetQuaDialog(false)}
					onSave={(selectedData: any[]) => {
						getKetQuaCanLamSang(selectedData);
					}}
					visitId={patientInfo.visitId}
				/>
			)}
		</div>
	);
};

export default TomTatKetQuaCanLamSang;
